import React from 'react'
import BG from "../assets/img/breadcrumb/01.jpg"
import { Link } from 'react-router-dom'

function BreadCrumb({pageName}) {
  return (
    <div className="site-breadcrumb" style={{background:`url(${BG})`}}>
        <div className="container">
            <h2 className="breadcrumb-title">{pageName}</h2>
            <ul className="breadcrumb-menu">
                <li><Link to="/">Home</Link></li>
                <li className="active">{pageName}</li>
            </ul>
        </div>
    </div>
  )
}

export default BreadCrumb